import { FileType } from '../../helpers/fileHelper';
import { isJsonResponse } from '../../helpers/isJsonResponse';
import { extractFilename } from '../../helpers/saveFileFromBlob';

export const formatMiddleware = async (
  response: Nullable<Response>,
  headers: Headers = new Headers(),
): Promise<any> => {
  if (response) {
    if (headers instanceof Headers && Object.values(FileType).includes(headers.get('Accept') as FileType)) {
      const contentDisposition = response.headers.get('content-disposition');
      return {
        fileId: response.headers.get('App-Attachment-Id'),
        fileName: contentDisposition ? extractFilename(contentDisposition) : null,
        file: await response.blob(),
      };
    }

    if (isJsonResponse(response)) {
      return response.json();
    }

    return response.text();
  }
};
